function getExtrasProductDataByAjax(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, allAjaxData) {
  if (!ajaxPage) ajaxPage = 0;
  if (!allAjaxData) allAjaxData = [];

  // Shopify only resolves up to 11 tags in a /collections/<handle>/<tag>+<tag> path; 12+ returns 404
  if (!numberProductPerAjaxCall || numberProductPerAjaxCall > 11){
    numberProductPerAjaxCall = 11;
  }
  var fromIndex = numberProductPerAjaxCall * ajaxPage;
  var toIndex = Math.min(data.length, numberProductPerAjaxCall * (ajaxPage + 1));
  var handles = [];
  for (var i = fromIndex; i < toIndex; i++) {
    handles.push(data[i].handle);
  }
  var handleString = handles.join("+");
	
	var url = Utils.buildProductItemUrl({handle: 'test' }, true);
  url = url.split('/products/')[0]
  
  if (!url.includes('collection')) {
    url += '/collections/all'
  } 
  
  var itemDataUrl = url + "/" + handleString + "?view=" + templateName;

  // Start fix BO - 63909322
  if(!Utils.isCollectionPage()) {
    itemDataUrl = itemDataUrl.replace("/collections//", "/collections/all/").replace("/account", "");
  }
  // End fix BO - 63909322

  jQ.ajax({
    type: "GET",
    url: itemDataUrl,
    success: function(ajaxData) {
      // the same call as buildExtrasProductListByAjax, with one extra params: ajaxData (the new data we just got from ajax call)
      onGetExtrasProductDataByAjaxSuccess(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, ajaxData, allAjaxData);
    },
    error: function(xhr) {
      // Never strand the caller - Boost waits on this callback to render the grid
      console.error('boost-pfs-wholesale: ' + itemDataUrl + ' failed (' + xhr.status + ')');
      if (typeof callback == 'function') callback(allAjaxData);
    }
  });
}

function onGetExtrasProductDataByAjaxSuccess(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, ajaxData, allAjaxData) {
  // Try to parse the json we get from collection endpoint
  try {
    if(/<\!--.*?-->/.test(ajaxData)){
      ajaxData = ajaxData.replace(/<\!--.*?-->/g, '');
    }
    // Add the new data to the "all data" list
    allAjaxData = allAjaxData.concat(JSON.parse(ajaxData).products);
  } catch (error) {
    console.error('Could not parse json from ' + templateName + ": " + error.message);
  }

  // We can only get 20 products per ajax call, if there are more than 20 products per page, we need to call multiple times
  var fromIndex = numberProductPerAjaxCall * ajaxPage;
  if (fromIndex < data.length - 1) {
    ajaxPage++;
    getExtrasProductDataByAjax(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, allAjaxData);
  } else {
    // After getting all products from all pages, call the callback function
    if (typeof callback == 'function') {
      callback(allAjaxData);
    }
  }
}

var currency = boostPFSConfig.general.current_currency.toLowerCase();

function getNewPrices(apiData, productsData) {
  const result = {...apiData, products: [...apiData.products]};
  
  productsData.forEach(function(product) {
    var idx = result.products.findIndex(function(apiProduct) { return apiProduct.id === product.id });
    if (idx >= 0) {
      result.products[idx].compare_at_price_min = product.compare_at_price_min / 100
      result.products[idx].price_min = product.price_min / 100
      result.products[idx].price_max = product.price_max / 100

      result.products[idx]['compare_at_price_min_' + currency] = product.compare_at_price_min / 100
      result.products[idx]['price_min_' + currency] = product.price_min / 100
      result.products[idx]['price_max_' + currency] = product.price_max / 100
      
      for (var variant of product.variants) {
        var vidx = result.products[idx].variants.findIndex(v => v.id === variant.id);
        if (vidx === -1) continue;
        
        result.products[idx].variants[vidx].price = variant.price / 100;
        result.products[idx].variants[vidx].compare_at_price = variant.compare_at_price / 100;
      }
    }          
  });

  return result;
}

// The /collections/<handle>/<h>+<h>?view=boost-wholesale endpoint resolves its handles through
// current_tags, but products are not tagged with their own handles - so it always responds with
// {"products": []} and can never adjust a price. Meanwhile Boost blocks grid rendering on this
// callback, so any failure here (Shopify 404s tag paths over 11 segments) leaves signed-in
// customers staring at empty skeletons. Skip the round-trip until that template is fixed.
var BOOST_WHOLESALE_PRICING_ENABLED = false;

if (typeof FilterApi !== 'undefined') {
  FilterApi.afterCallAsync = function(result, callbackFilterApi) {      
    var currency = boostPFSConfig.general.current_currency.toLowerCase();
    if (!BOOST_WHOLESALE_PRICING_ENABLED || result.products.length === 0 || !boostPFSConfig.customer.isLogged) { /* currency check */
      callbackFilterApi(result);
      return;
    }

    getExtrasProductDataByAjax(result.products, "boost-wholesale", function(productsData) {
      callbackFilterApi(getNewPrices(result, productsData));
    });
  }
}

if (typeof InstantSearchApi !== 'undefined') {
  InstantSearchApi.afterCallAsync = function(result, callbackInstantSearchApi) {
    var currency = boostPFSConfig.general.current_currency.toLowerCase();

    if (!BOOST_WHOLESALE_PRICING_ENABLED || result.products.length === 0 || !boostPFSConfig.customer.isLogged) { /* currency check */
      callbackInstantSearchApi(result);
      return;
    }

    getExtrasProductDataByAjax(result.products, "boost-wholesale", function(productsData) {
      callbackInstantSearchApi(getNewPrices(result, productsData));
    });
  }
}